import React from "react";
import { Box, Typography, Grid } from '@mui/material';
import SubjectCard from "./Card/SubjectCard";
import Data from "../pages/Data/Activitie.json";
import Container from '@mui/material/Container';

const Subject = () => {
    const currentSubject = Data?.Subject || []; // Ensure `currentSubject` is safely accessed

    if (!currentSubject.length) {
        console.error("No subjects found in data.");
        return (
            <Box sx={{ p: 4, textAlign: "center" }}>
                <Typography variant="h4" color="error">
                    No Subjects Available
                </Typography>
            </Box>
        );
    }

    return (

        <Container maxWidth="lg">
            <Box sx={{ p: 4, textAlign: "center" }}>
                <Typography
                    variant="h3"
                    sx={{ fontWeight: "bold", color: "#1976d2" }}
                >
                    Subjects
                </Typography>
                <Grid container spacing={4} justifyContent="center">
                    {currentSubject.map((subject, index) => (
                        <Grid item size={{ xs: 12, md: 6, lg: 6 }} key={index}>
                            <SubjectCard
                                image={subject.image}
                                title={subject.title}
                                description={subject.description}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Container>

    );
};

export default Subject;
